import styled from 'styled-components'
import { backgroundOrange } from '@/theme/colors'

export const ItineraryPageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

export const LoadingContainer = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
	background-color: ${backgroundOrange};
	height: 100%;
`


